// Clipboard
export default function initClipboard() {
	function clickHandler(e) {
		e.preventDefault();

		const $btn = jQuery(this);
		const textToCopy = $btn.data('clipboardText');
		let stateTimer = $btn.data('stateTimer') || null;

		clearTimeout(stateTimer);

		$btn
			.removeClass('copy-success')
			.removeClass('copy-error');

		copyTextToClipboard(textToCopy, (msg) => {
			if (msg == 'success') {
				$btn.addClass('copy-success');

				stateTimer = setTimeout(() => {
					$btn.removeClass('copy-success');
				}, 2000);

				$btn.data('stateTimer', stateTimer);
			} else {
				$btn.addClass('copy-error');

				stateTimer = setTimeout(() => {
					$btn.removeClass('copy-error');
				}, 2000);

				$btn.data('stateTimer', stateTimer);
			}
		});
	}

	function copyTextToClipboard(textToCopy, cb) {
		try {
			let tempInput = document.createElement("textarea");
			tempInput.value = textToCopy;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand("copy");
			document.body.removeChild(tempInput);
			cb('success');
		} catch (err) {
			cb('error');
		}
	}

	jQuery(document).on('click', '[data-clipboard-text]', clickHandler);
}